import { DocumentData, DocumentSnapshot } from "@firebase/firestore-types";
import { plainToClass } from "class-transformer";
import firebase from "firebase/compat/app";

function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (value === null || typeof value !== "object") {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}

export function normalizeTimestampsInData(
  obj: Record<string, unknown>
): Record<string, unknown> {
  const out = { ...obj };
  for (const [key, value] of Object.entries(out)) {
    if (
      typeof value === "string" &&
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)
    ) {
      const ms = Date.parse(value);
      if (Number.isFinite(ms)) {
        out[key] = firebase.firestore.Timestamp.fromMillis(ms);
      }
    } else if (
      isPlainObject(value)
    ) {
      out[key] = normalizeTimestampsInData(value);
    } else if (Array.isArray(value)) {
      out[key] = value.map((item) =>
        isPlainObject(item)
          ? normalizeTimestampsInData(item)
          : item
      );
    }
  }
  return out;
}

const isTimestamp = (
  timestamp: any
): timestamp is firebase.firestore.Timestamp => {
  return (
    !!timestamp &&
    typeof timestamp === "object" &&
    typeof timestamp.toDate === "function"
  );
};

export function convertDocToClass(
  doc: DocumentSnapshot<DocumentData>,
  cls: { new (...args: any[]): any }
) {
  const JObject = {
    id: doc.id,
    ...Object.fromEntries(
      Object.entries(doc.data()).map(([key, value]) => {
        value = isTimestamp(value) ? value.toDate() : value;
        return [key, value];
      })
    ),
  };
  return plainToClass(cls, JObject);
}
